<script>
import { avatarTools } from '@/mixins/avatarTools'
import AvatarWrapper from '@/components/_common/AvatarWrapper.vue'
import { mapGetters } from 'vuex'
import getAvatarInfo from '@/graphql/query/getAvatarInfo'
export default {
  name: 'MainNavAvatar',
  components: {
    AvatarWrapper
  },
  mixins: [avatarTools],
  data () {
    return {
      avatarDetails: null
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo',
      avatarKey: 'user/userAvatarKey'
    }),
    userId () {
      return this.userInfo.id
    },
    userName () {
      return this.userInfo ? `${this.userInfo.firstName} ${this.userInfo.lastName}` : ''
    },
    firstName () {
      return this.userInfo ? this.userInfo.firstName : ''
    },
    lastName () {
      return this.userInfo ? this.userInfo.lastName : ''
    },
    isMobile () {
      return this.$mq
    },
    hideLogoutBtn () {
      // we don't want to show the logout button when In-Office-Play is being used as it is confused with stopping in office play
      // adding text because I want a new deploy but after 5PM (cancelled last one)
      return (
        (this.$mq !== 'mobile') ||
        (this.$store.state.user.actualAppUserInfo !== null &&
        this.$store.state.user.actualAppUserInfo.appUserId !== this.$store.state.user.userInfo.appUserId &&
        (this.$store.state.user.scopeAppUserInfo ? this.$store.state.user.scopeAppUserInfo.appUserId !== this.$store.state.user.userInfo.appUserId : true))
      )
    }
  },
  methods: {
    async logout () {
      // console.log('[MainNavAvatar] LOGOUT CLICKED!')

      // Show global loading overlay and navigate immediately
      await this.$store.dispatch('application/setGlobalLoading', {
        show: true,
        message: 'Logging you out...'
      })

      // console.log('[MainNavAvatar] Overlay shown, navigating to PreLogout')

      // Navigate immediately to PreLogout which handles the actual logout
      this.$router.push({ name: 'PreLogout' })
    },
    clearCache () {
      alert('Clearing cache...')
    }
  },
  apollo: {
    getAvatarInfo: {
      query: getAvatarInfo,
      variables () {
        return {
          id: this.userInfo.appUserId
        }
      },
      update (data) {
        this.$store.dispatch('user/setUserAvatarKey', data.appUserById.avatarKey)
      }
    }
  }
}
</script>

<template>
  <section
    class="nav-avatar-section"
  >
    <div class="nav-avatar-container">
      <div class="avatar-box">
        <avatar-wrapper
          :user-name="userName"
          :image-key="avatarKey"
          :format="avatarInfo ? avatarInfo.format : null"
          :source="avatarInfo ? avatarInfo.source : null"
          :fallback="avatarInfo ? avatarInfo.fallback : null"
          :size="80"
          :rounded="false"
          :styles="'padding: 0.5rem;'"
          class="mb-4 mr-4"
        />
      </div>
      <div
        class="user-name"
      >
        <div class="user-name">
          {{ firstName }}
        </div>
        <div class="user-name">
          {{ lastName }}
        </div>
      </div>
    </div>
    <div class="is-flex is-justify-content-space-between">
      <div
        v-if="!hideLogoutBtn"
        class=""
      >
        <button
          class="button is-info is-small"
          @click="logout"
        >
        <span class="icon is-medium mr-1">
          <i class="mdi mdi-18px mdi-logout" />
        </span>
          <span class="is-family-semibold">Log Out</span>
        </button>
      </div>
    </div>

  </section>
</template>

<style scoped lang="scss">
.user-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.support-section {
  background-color: $feldgrau;
}
.nav-avatar {
  &-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    //align-items: center;
    flex-grow: 1;
  }
  &-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .avatar-box {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
  &-info {
    background-color: red;
    margin-left: 1rem;
  }
}
.user-name {
  color: $page-background;
  font-size: 1.5rem;
  line-height: 1.5rem;
}
.user-scope {
  color: $page-background;
  font-size: 1.00rem;
}
.app-tenant-scope {
  color: $page-background;
  font-size: 1.00rem;
}
</style>
